import { X } from "lucide-react";
import styles from "./Modal.module.css";
import type { modalProps } from "./types.props";

const Modal: React.FC<modalProps> = ({ isOpen, children, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className={styles["modal-overlay"]} onClick={onClose}>
            <div
                className={styles["modal-content"]}
                onClick={(e) => e.stopPropagation()}
            >
                <button onClick={onClose} className={styles["modal-close-btn"]}>
                    <X size={24} />
                </button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
